import { PersonAddAlt1, FactCheck, TaskAlt } from "@mui/icons-material";
import { Paper, Container, Box } from "@mui/material";
import {
  getCurrentUserData,
  validateUserProfile,
} from "Application/User/UserService";
import { User, UserEntity } from "Domain/User/Entity/User";
import Button from "pages/components/FormFields/Button";
import StatusProgress from "pages/components/Molecules/StatusProgress";
import { useTranslation } from "react-i18next";

type ProfileFormProps = {
  userData: User;
  setUserData: Function;
};

export default function ProfileStatus({
  userData,
  setUserData,
}: ProfileFormProps) {
  const userEntity = new UserEntity(userData);
  const { t } = useTranslation();

  const currentUser = getCurrentUserData();
  if (currentUser.isUserInternal()) {
    return (
      <InternalProfileStatus
        userEntity={userEntity}
        setUserData={setUserData}
      />
    );
  }
  if (currentUser.isCreditorValidated()) {
    return <></>;
  }

  const steps = [
    {
      label: t("STEPS.account_creation.label"),
      text: t("STEPS.account_creation.text"),
      icon: PersonAddAlt1,
    },
    {
      label: t("STEPS.account_completion.label"),
      text: t("STEPS.account_completion.text"),
      icon: FactCheck,
    },
    {
      label: t("STEPS.sign_contract.label"),
      text: t("STEPS.sign_contract.text"),
      icon: FactCheck,
    },
    {
      label: t("STEPS.internal_validation.label"),
      text: t("STEPS.internal_validation.text"),
      icon: TaskAlt,
    },
  ];

  let currentStep = 0;
  if (userEntity.isCreditorCreated()) {
    currentStep = 1;
  }
  if (userEntity.isCreditorCompleted()) {
    currentStep = 2;
  }
  if (userEntity.isContractSigned()) {
    currentStep = 3;
  }
  return (
    <StatusProgress
      title={t("STEPS.title_account_state")}
      steps={steps}
      currentStep={currentStep}
    />
  );
}

type InternalProfileStatusProps = {
  userEntity: UserEntity;
  setUserData: Function;
};

function InternalProfileStatus({
  userEntity,
  setUserData,
}: InternalProfileStatusProps) {
  const { t } = useTranslation();
  function validateProfile() {
    validateUserProfile(userEntity.userData.publicId).then((user) => {
      setUserData(user);
    });
  }

  if (userEntity.isCreditorValidated()) {
    return <></>;
  }
  let content;
  if (userEntity.isCreditorCreated()) {
    content = <div>{t("STEPS.internal_profile_created_status")}</div>;
  } else {
    content = (
      <div>
        <div>{t("STEPS.internal_profile_completed_status")}</div>
        <Box sx={{ position: "relative", width: "100%", height: "40px" }}>
          <Button
            sx={{ position: "absolute", right: 0 }}
            onClick={validateProfile}
            label={t("FORM.SUBMIT.validate")}
          ></Button>
        </Box>
      </div>
    );
  }

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          marginBottom: 4,
          marginTop: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
        }}
      >
        {content}
      </Paper>
    </Container>
  );
}
